import { render, staticRenderFns } from "./user-feedback-form.vue?vue&type=template&id=580d2be3&scoped=true&"
import script from "./user-feedback-form.vue?vue&type=script&lang=js&"
export * from "./user-feedback-form.vue?vue&type=script&lang=js&"
import style0 from "./user-feedback-form.vue?vue&type=style&index=0&id=580d2be3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d2be3",
  null
  
)

export default component.exports